<template>
    <form @submit.prevent="handleSubmit">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Schedule LOC Email</p>
            </header>
            <section class="modal-card-body">
                 <o-field label="Postpone Loc Email:">
                    <datepicker :config="config" v-model="date" :absolute="true" :required="true" v-bind:class="{ 'is-danger': !date }" />
                </o-field>
                <o-field v-if="shouldEnterNotes">
                    <o-input v-model="notes" placeholder="What would you like to say?" maxlength="200" type="textarea"></o-input>
                </o-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)" v-if="!shouldEnterNotes">Close</button>
                <button @click="handleClick()" class="button is-primary" :disabled="!isValid">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Datepicker from './../Datepicker'


    export default {
        mixins: [],

        components: {
            Datepicker
        },

        props: {
            entity_type: {
                type: String // project-service
            },
            entity: {
                type: Object
            },
            shouldEnterNotes: {
                type: Boolean
            }
        },

        mounted() {
           this.date = this.entity.remind_by
        },

        data () {
            return {
                config: {
                    minDate: 'today'
                },
                date: null,
                notes: ''
            }
        },

        methods: {
            ...mapActions(['scheduleLocEmail']),
            schedule(obj) {
                switch(this.entity_type){
                    case 'project-service' :
                        this.scheduleLocEmail(obj)
                        break
                }
            },
            handleClick() {
                this.schedule({ id: this.entity.id, loc_send_date: this.date, notes: this.notes})
                this.$parent.$parent.$emit('update:active', false)
            },
            handleSubmit() {
                return false
            }
        },

        computed: {
            ...mapGetters([]),
            isValid() {
                return this.date && (!this.shouldEnterNotes || (this.shouldEnterNotes && this.notes) )
            }
        }
    }
</script>
<style scoped>
    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal-card-foot button {
        margin: 0px 2px;
        min-width: 80px;
        justify-content: center;
    }

    .modal .modal-card {
        max-width: 460px;
        width: auto;
    }
    .modal .modal-card .modal-card-head {
        font-size: 1.25rem;
        font-weight: 600;
    }
</style>
